import { addHashedData } from "./addHashedData.es.js";
import { extractClickData } from "./extractClickData.es.js";
import { extractCommonPayload } from "./extractCommonPayload.es.js";
import { extractIds } from "./extractIds.es.js";
import { getFormData } from "./extractFormData.es.js";
import { p as pickFields } from "../../../pickFields-27454ddf.js";
import { v as videoData } from "../../../videoData-64ad3ea2.js";
import "./hashUtils.es.js";
import "../../constants/analytics.es.js";
import "../../../analytics-plugin-original-source.browser.es-e6f690eb.js";
import "./getUtmParams.es.js";
import "../../../mapKeys-251205e5.js";
import "./pageUtils.es.js";
import "../../constants/profileFields.es.js";
import "./getBrowserID.es.js";
import "../../../cookies-04bd2321.js";
import "../../../utils/logger.es.js";
import "../../../v4-88c20f3b.js";
import "../../../server/validation/defaultSchema.es.js";
import "../../../_commonjsHelpers-7a77ea84.js";
const omitFields = (fields, obj) => {
  if (!fields || !obj) {
    return obj;
  }
  const result = { ...obj };
  fields.forEach((field) => delete result[field]);
  return result;
};
const generateTealiumPayload = async (application, fields, payload, type) => {
  var _a, _b, _c;
  const props = payload == null ? void 0 : payload.properties;
  const allData = props == null ? void 0 : props.application_data;
  const applicationData = fields ? pickFields(fields, allData) : allData;
  const pageName = props == null ? void 0 : props.page_name;
  const clickData = extractClickData(payload.properties, application);
  const eventAction = type === "page" ? "page_view" : props == null ? void 0 : props.event_action;
  const eventName = type === "page" ? "Page Loaded" : payload.event;
  let tealiumFormData = {};
  if ((_a = payload == null ? void 0 : payload.properties) == null ? void 0 : _a.form) {
    ({ tealiumFormData } = await getFormData((_b = payload == null ? void 0 : payload.properties) == null ? void 0 : _b.form) || {});
  }
  const hashedData = await addHashedData(applicationData);
  const appData = { ...applicationData, ...hashedData };
  const extractedId = await extractIds(payload);
  const video = videoData(payload);
  return {
    referrer: ((_c = payload == null ? void 0 : payload.properties) == null ? void 0 : _c.referrer) || null,
    ...omitFields(["form_email", "form_phone"], appData),
    ...extractCommonPayload(payload, application),
    ...omitFields(["auth0_email"], extractedId),
    ...clickData,
    ...video,
    event_action: eventAction,
    event_name: `${pageName} - ${eventName}`,
    ...tealiumFormData,
    lead_stage: payload.properties.lead_stage || null,
    lead_type: payload.properties.lead_type || null,
    page_view_id: payload.properties.page_view_id,
    tealium_event: eventAction,
    time_since_last_event: payload.properties.time_since_last_event
  };
};
export {
  generateTealiumPayload
};
